import { useState, useEffect } from 'react';
import { getContributionReport, getMemberReport } from '../../services/reports';
import DataTable from '../../components/Tables/DataTable';
import BarChart from '../../components/Charts/BarChart';

const Reports = () => {
  const [contributions, setContributions] = useState([]);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    loadReports();
  }, []);

  const loadReports = async () => {
    try {
      const [contributionData, memberData] = await Promise.all([
        getContributionReport(),
        getMemberReport(),
      ]);
      setContributions(contributionData.contributions || []);
      setTotalAmount(contributionData.totalAmount || 0);
      setMembers(memberData || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const contributionColumns = [
    { key: 'member.full_name', label: 'Member' },
    { key: 'case.type', label: 'Case Type' },
    { key: 'amount', label: 'Amount (KSh)' },
    { key: 'paid_at', label: 'Paid Date' },
  ];

  const memberColumns = [
    { key: 'member_number', label: 'Member ID' },
    { key: 'full_name', label: 'Name' },
    { key: 'status', label: 'Status' },
    { key: 'missed_pay_count', label: 'Missed Payments' },
  ];

  return (
    <div>
      <h1>Unit Reports</h1>
      <div style={{ marginBottom: '2rem' }}>
        <h2>Total Contributions: KSh {totalAmount.toLocaleString()}</h2>
      </div>
      <h2>Contribution History</h2>
      <DataTable columns={contributionColumns} data={contributions} loading={loading} />
      <h2>Members List</h2>
      <DataTable columns={memberColumns} data={members} loading={loading} />
    </div>
  );
};

export default Reports;